const CARD_WIDTHS = [256, 320, 384, 512, 640, 960, 1280];
const CARD_QUALITY = 72;

const normalizedWidth = (requestedWidth) => {
  const width = Number(requestedWidth);
  if (!Number.isFinite(width) || width <= 0) return CARD_WIDTHS[1];
  return (
    CARD_WIDTHS.find((candidate) => candidate >= width) ||
    CARD_WIDTHS[CARD_WIDTHS.length - 1]
  );
};

const transformationBase = () => {
  const origin = process.env.REACT_APP_IMAGE_TRANSFORM_ORIGIN?.trim();
  if (!origin) return null;

  const base = origin.replace(/\/+$/, "");
  return base.endsWith("/cdn-cgi/image")
    ? base
    : `${base}/cdn-cgi/image`;
};

export const artworkImageUrl = (source, requestedWidth) => {
  const base = transformationBase();
  if (!base || !/^https?:\/\//i.test(source || "")) return source;

  const width = normalizedWidth(requestedWidth);
  return `${base}/width=${width},quality=${CARD_QUALITY},format=auto,fit=scale-down/${source}`;
};

export const artworkImageSrcSet = (
  source,
  requestedWidths = [256, 320, 384, 512, 640]
) => {
  if (!transformationBase() || !/^https?:\/\//i.test(source || "")) {
    return undefined;
  }

  const widths = [...new Set(requestedWidths.map(normalizedWidth))];
  return widths
    .map((width) => `${artworkImageUrl(source, width)} ${width}w`)
    .join(", ");
};

export const artworkImageDimensions = (size) => {
  const match = String(size || "").match(/^(\d+)x(\d+)$/i);
  if (!match) return {};

  const width = Number(match[1]);
  const height = Number(match[2]);
  if (!width || !height) return {};

  // Historical provider size labels do not always match the normalized file
  // written to storage (for example, 1024x1792 jobs are stored at 1024x1536).
  // Public artwork files use one of these three canonical aspect ratios.
  if (width === height) return { width: 1024, height: 1024 };
  return width > height
    ? { width: 1536, height: 1024 }
    : { width: 1024, height: 1536 };
};

export const restoreOriginalArtwork = (source) => (event) => {
  const image = event.currentTarget;
  if (!source || image.src === source) return;

  image.srcset = "";
  image.src = source;
};

export { CARD_WIDTHS };
